<template>
  <div class="my-order" ref="container">
    <div class="list">
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">
            <span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.combination_id > 0"
              >拼团</span
            ><span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.seckill_id > 0"
              >秒杀</span
            ><span
              class="sign cart-color acea-row row-center-wrapper"
              v-if="order.bargain_id > 0"
              >砍价</span
            >
            {{ order._add_time }}
          </div>
          <div class="font-color-red">
            {{order.presellOrder.activeStatus === 0 ? '未开始' : order._status._title}}</div>
        </div>
        <div @click="$router.push({ path: '/order/detail/' + order.order_id })">
          <div
            class="item-info acea-row row-between row-top"
            v-for="cart in order.cartInfo"
            :key="cart.id"
          >
            <div class="pictrue">
              <!-- 普通 -->
              <img
                :src="cart.productInfo.image"
                @click.stop="
                  $router.push({ path: '/activity/presell_details/' + cart.productInfo.productPresell.product_presell_id })
                "
              />
            </div>
            <div class="text acea-row row-between">
              <div class="name line1">
                <span>{{ cart.productInfo.productPresell.store_name }}</span>
                <div
                  class="send-time" 
                  v-if="cart.productInfo.productPresell.presell_type === 2">
                  发货时间：{{cart.productInfo.productPresell.delivery_type === 1? "支付尾款后" : "预售结束后"}}{{ cart.productInfo.productPresell.delivery_day}}天内
                </div>
              </div>
              <div class="money">
                <div>
                  ￥{{cart.productInfo.productPresellAttr.presell_price}}
                </div>
                <div>x{{ cart.cart_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          <span class="pay_paid">定金已支付￥{{order.pay_price}}，</span>
          <span class="to_paid">尾款待支付￥<span class="money">{{ order.presellOrder.pay_price }}</span></span>
          <!-- 共{{ order.cartInfo.length || 0 }}件商品，总金额
          <span class="money font-color-red">￥{{ order.pay_price }}</span> -->
        </div>
        <div class="bottom acea-row row-right row-middle">
          <template
            v-if="order.presellOrder.activeStatus === 2"
          >
            <div class="bnt cancelBnt" @click="cancelOrder(order)">
              取消订单
            </div>
          </template>
          <template v-if="order.presellOrder.activeStatus === 1">
            <div class="bnt bg-color-red" @click="paymentTap(order)">
              立即付尾款
            </div>
          </template>
          <template
           v-if="order.presellOrder.activeStatus === 0"
          >
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/order/detail/' + order.order_id })"
            >
              未开始
            </div>
          </template>
        </div>
      </div>
    </div>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
  </div>
</template>
<script>
import { getOrderList , getOrderData } from "@api/order";
import Payment from "@components/Payment";
import { mapGetters } from "vuex";
import { payPresellOrderHandle  } from "@libs/order"
export default {
  name: "PresellOrderList",
  data() {
    return {
      loading: false, //是否加载中
      loadend: false, //是否加载完毕
      loadTitle: "加载更多", //提示语
      orderList: [], //订单数组
      orderData: {}, //订单详细统计
      orderStatus: 0, //订单状态
      page: 1,
      limit: 20,
      payType: ["yue", "weixin"],
      pay: false,
    };
  },
  components:{
    Payment
  },
  mounted() {
    this.getOrderList();
  },
  computed: mapGetters(["userInfo"]),
  methods: {
    getOrderList() {
      let that = this;
      if (that.loadend) return;
      if (that.loading) return;
      that.loading = true;
      that.loadTitle = "加载更多";
      getOrderList({
        type: 10,
        page: that.page,
        limit: that.limit,
      })
        .then((res) => {
          this.orderList = this.orderList.concat(res.data);
          this.page++;
          this.loaded = res.data.length < this.limit;
          this.loading = false;
        })
        .catch((err) => {
          that.loading = false;
          that.loadTitle = "加载更多";
        });
    },
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    getOrderData() {
      getOrderData().then(res => {
        this.orderData = res.data;
      });
    },
    takeOrder(order) {
      this.$dialog.loading.open("正在加载中");
      takeOrderHandle(order.order_id)
        .then(res => {
          if (
            (res.data.gain_integral != "0.00" &&
              res.data.gain_coupon != "0.00") ||
            (res.data.gain_integral > 0 && res.data.gain_coupon > 0)
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${res.data.gain_coupon}元优惠券以及${
                res.data.gain_integral
              }积分，购买商品时可抵现哦～`,
              title: "恭喜您获得优惠礼包"
            };
            return;
          } else if (
            res.data.gain_integral != "0.00" ||
            res.data.gain_integral > 0
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${
                res.data.gain_integral
              }积分，购买商品时可抵现哦～`,
              title: "赠送积分"
            };
            return;
          } else if (
            res.data.gain_coupon != "0.00" ||
            res.data.gain_coupon > 0
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${
                res.data.gain_coupon
              }元优惠券，购买商品时可抵现哦～`,
              title: "恭喜您获得优惠券"
            };
            return;
          } else {
            this.$dialog.loading.close();
            this.$dialog.success("收货成功");
          }
          this.getOrderData();
          this.orderList = [];
          this.page = 1;
          this.loaded = false;
          this.loading = false;
          this.getOrderList();
        })
        .catch(err => {
          this.$dialog.loading.close();
          this.$dialog.error(err.msg);
        });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.reload();
      this.getOrderData();
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getStatus(order) {
      return STATUS[order._status._type];
    },
    cancelOrder(order) {
      cancelOrderHandle(order.order_id)
        .then(() => {
          this.getOrderData();
          this.orderList.splice(this.orderList.indexOf(order), 1);
        })
        .catch(() => {
          this.reload();
        });
    },
    paymentTap: function(order) {
      var that = this;
      if (
        !(
          order.combination_id > 0 ||
          order.bargain_id > 0 ||
          order.seckill_id > 0
        )
      ) {
        that.setOfflinePayStatus(order.offlinePayStatus);
      }
      this.pay = true;
      this.toPay = type => {
        payPresellOrderHandle(order.order_id, type, that.from)
          .then(() => {
            const type = parseInt(this.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
            that.$router.push({
              path:"/order/list/1"
            })
          })
          .catch(res => {
            if (res.status === "WECHAT_H5_PAY")
              return that.$router.push({
                path: "/order/status/" + order.order_id + "/5"
              });
            const type = parseInt(that.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          });
      };
    },
    toPay() {},
    /**
     * 获取定金预售订单列表
     */
    getpreSellOrderList(){
      let that = this;
      let data = {
        type : 10,
        page:1,
        limit:10
      }
      getOrderList(data).then(res => {
        let list = res.data || [];
        that.$set(that,'preSellOrderList',list);
      })
    }
  },
};
</script>
<style scoped>
.my-order .list .item .item-info .text{
  height: 1.2rem;
}
.my-order .list .item .item-info .text .name{
  width: 3.4rem;
}
.my-order .list .item .item-info .text .name .send-time{
  font-size: .24rem;
  color: #c9975c;
  margin-top: .1rem;
}
.totalPrice .pay_paid{
  color: #999;
}
</style>